import { useEffect, useRef } from "react";
import { userRoles } from "../../constant";
import { PRAXIS_PLAY_EVENTS } from "../../integrations/posthog/events";
import { useAnalytics } from "../../integrations/posthog/useAnalytics";
import { useUser } from "../../services/user-context";
import { ManagerDashboard } from "./ManagerDashboard";
import { UserDashboard } from "./UserDashboard";
import { getDeviceType } from "../../services/utils";

export function Dashboard() {
  const { userInfo } = useUser() as any;
  const role = userInfo?.role;
  const pageRef = useRef(0);
  const { captureEvent } = useAnalytics();

  useEffect(() => {
    if (pageRef.current !== 0) {
      return;
    }
    const userName = userInfo?.firstName;
    if (userName) {
      pageRef.current = 1;
      captureEvent(PRAXIS_PLAY_EVENTS.DASHBOARD_ACCESSED, {
        user_name: userName,
        device_type: getDeviceType(),
        viewport_width: window.innerWidth,
      });
    }
  }, [userInfo]);

  return <UserDashboard />;
}
